import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../../../_helpers/Api'

//images
import loader from '../../../../../../assets/img/loader.svg'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import { trans } from '../../../../../../_providers/Translation'
import { Checkbox, FormControlLabel, Tab, Tabs } from '@mui/material'

import StorageStatusAutoCondition from '../StorageStatusAutoCondition'
import Skeleton from 'react-loading-skeleton'

function StorageStatus(props, ref) {

    const getNewTransition = () => ({
        id: Date.now(),
        initialStatusId: '',
        finalStatusId: '',
    })
    const [transitions, setTransitions] = useState([getNewTransition()])

    const updateTransitionField = (index, field, value) => {
        setTransitions(prev => prev.map((transition, i) =>
            i === index ? { ...transition, [field]: value } : transition
        ))
    }

    const addTransition = () => {
        setTransitions(prev => [...prev, getNewTransition()])
    }

    const removeTransition = (index) => {
        setTransitions(prev => prev.filter((_, i) => i !== index))
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        id: null,
        data: {},
        groups: [],
        tab: 'main',
        loading: false,
        loadingData: false,
        update: false,
        onSave: null
    })

    const [validations, setValidations] = useState(null)
    const [submitAttempted, setSubmitAttempted] = useState(false)

    const [statuses, setStatuses] = useState([])
    const [reservationActions, setReservationActions] = useState([])
    const [finalStatuses, setFinalStatuses] = useState([])
    const [initialStatuses, setInitialStatuses] = useState([])

    useEffect(() => {
        Api.get('/storage/statuses')
            .then(response => {
                setStatuses(response.data)
            })
            .catch(error => {
                console.error('Error loading statuses:', error)
            })
    }, [])

    useEffect(() => {
        Api.get('/storage/statuses/transitions/actions')
            .then(response => {
                setReservationActions(response.data)
            })
            .catch(error => {
                console.error('Error loading reservation final statuses:', error)
            })
    }, [])

    useEffect(() => {
        if (popup.id) {
            Api.get('reservations/initial-and-final-statuses')
                .then(res => {
                    setInitialStatuses(Array.isArray(res.data?.initial) ? res.data.initial : [])
                    setFinalStatuses(Array.isArray(res.data?.final) ? res.data.final : [])
                })
                .catch(error => {
                    console.error('Error loading reservation final statuses:', error)
                })
        }
    }, [popup.id])

    useImperativeHandle(ref, () => ({
        open: () => {
            handleShow()
        },
        edit: id => {
            setPopup(prev => ({
                ...prev,
                id: id,
                tab: 'main',
                update: new Date().getTime()
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }))
        }
    }))

    useEffect(() => {
        if (popup.id) {
            setPopup(prev => ({
                ...prev,
                loadingData: true,
            }))

            Api.get('storage/statuses/find?id=' + popup.id)
                .then(res => {
                    setPopup(prev => ({
                        ...prev,
                        data: res.data
                    }))

                    if (res.data.auto_transitions && res.data.auto_transitions.length > 0) {
                        setTransitions(res.data.auto_transitions.map(t => ({
                            id: t.id,
                            initialStatusId: t.res_initial_status_id,
                            finalStatusId: t.res_final_status_id
                        })))
                    } else {
                        setTransitions([getNewTransition()])
                    }
                })
                .finally(() => {
                    setPopup(prev => ({
                        ...prev,
                        loadingData: false,
                    }))
                })
        }
    }, [popup.update])

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
            data: null
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false,
                id: null,
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        // Validate that all transitions have final status
        const hasEmptyFinalStatus = transitions.some(t => !t.finalStatusId)
        if (hasEmptyFinalStatus) {
            setSubmitAttempted(true)
            return
        }

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)
        setSubmitAttempted(false)

        let url = 'storage/statuses/' + (popup.id ? 'edit' : 'add')

        let data = new FormData()

        if (popup.id) {
            data.append('id', popup.id)
        }

        // Build from state so both tabs' data is always included
        if (popup.data) {
            Object.entries(popup.data).forEach(([key, value]) => {
                if (value !== null && value !== undefined) {
                    data.append(key, value)
                }
            })

            if (popup.data.no_changes_notific_after === null || popup.data.no_changes_notific_after === undefined) {
                data.append('no_changes_notific_after', '7')
            }
        }

        // Append transitions
        transitions.forEach((transition, index) => {
            data.append(`transitions[${index}][statusId]`, popup.id)
            data.append(`transitions[${index}][initialStatusId]`, transition.initialStatusId || '')
            data.append(`transitions[${index}][finalStatusId]`, transition.finalStatusId || '')
        })

        Api.post(url, data)
            .then(res => {

                handleHide(e)

                if (typeof popup.onSave === 'function') {
                    popup.onSave(res.data)
                }

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = (e) => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleCheckboxChange = e => {
        let name = e.target.name
        let val = e.target.checked ? 1 : 0

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    function handleTabs(e, newValue) {
        setPopup(prev => ({
            ...prev,
            tab: newValue,
        }))
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-status-parts popup-primary large`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {popup.id ? trans('headings.editPartStatus') : trans('headings.addPartStatus')}
                        </h2>
                        <p>{trans('subheadings.editPartStatus')}</p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>
                {popup.loadingData ?
                    <Skeleton height={50} count={5} />
                    :
                    <>
                        {popup.data?.id ?
                            <Tabs
                                value={popup.tab}
                                onChange={handleTabs}
                                variant="scrollable"
                                scrollButtons="auto"
                                indicatorColor="primary"
                                textColor="primary"
                            >
                                <Tab value="main" label={trans('tabs.mainInfo')} />
                                <Tab value="auto" label={trans('tabs.autoStatusChangeSettings')} />
                            </Tabs>
                            :
                            <>
                            </>
                        }
                        {popup.tab === 'main' &&
                            <>
                                <div className="row">
                                    <div className="col">
                                        <div className='color-and-name-fields'>
                                            <label>
                                                {trans('labels.statusNameAndColor')}
                                            </label>
                                            <div className='row'>
                                                <input
                                                    type="color"
                                                    name="color"
                                                    className={validations && validations.checkbox ? 'validate' : ''}
                                                    value={popup.data && popup.data.color ? popup.data.color : ''}
                                                    onChange={handleInputChange}
                                                />
                                                <input
                                                    name='name'
                                                    type="text"
                                                    value={popup.data ? popup.data.name : ''}
                                                    className={validations && validations.name ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                    placeholder={trans('labels.enterName')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className='status-field'>
                                            <label>
                                                {trans('labels.position_after')}
                                            </label>
                                            <span
                                                style={{
                                                    backgroundColor: popup.data?.position_after === "" ? "#9b9b9bff" : popup.data?.position_after === "set_as_initial_status" ? "#18e1a2ff" : (statuses.find(status => Number(status.position) === Number(popup.data?.position_after))?.color || '#9b9b9bff'),
                                                }}
                                            >

                                            </span>
                                            <select name="position_after" value={popup.data ? popup.data?.position_after : ''} onChange={handleInputChange}>
                                                <option value="">{trans('labels.choose_status')}</option>
                                                <option value="set_as_initial_status">{trans('labels.setAsInitialStatus')}</option>
                                                {statuses.map(status => (
                                                    <option key={status.position} value={status.position}>
                                                        {(status.position + 1) + '. ' + status.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                <div className="row" style={{ marginBottom: 0 }}>
                                    <div className="col">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="default"
                                                    value="1"
                                                    checked={popup.data && popup.data.default}
                                                    onChange={handleCheckboxChange}
                                                    size="small"
                                                />
                                            }
                                            label={trans('random.byDefaultWhenAddingPart')}
                                        />
                                    </div>
                                </div>

                                <div className="row" style={{ marginBottom: 0 }}>
                                    <div className="col">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="show_in_dashboard"
                                                    value="1"
                                                    checked={popup.data && popup.data.show_in_dashboard}
                                                    onChange={handleCheckboxChange}
                                                    size="small"
                                                />
                                            }
                                            label={trans('random.visibleInContractorsDashboard')}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="no_changes_notific_on"
                                                    value="1"
                                                    checked={popup.data && popup.data.no_changes_notific_on}
                                                    onChange={handleCheckboxChange}
                                                    size="small"
                                                />
                                            }
                                            label={trans('random.sendNotificationIfNoChangesOn')}
                                        />
                                    </div>
                                </div>
                                {popup.data && popup.data.no_changes_notific_on ?
                                    <div className='row'>
                                        <div className="col" style={{ width: "fit-content" }}>
                                            <label>
                                                {trans('labels.periodForNotification')}
                                            </label>
                                            <select name="no_changes_notific_after" value={popup.data ? popup.data.no_changes_notific_after : ''} onChange={handleInputChange}>
                                                <option value="7"> {trans('random.1week')}</option>
                                                <option value="14"> {trans('random.2weeks')}</option>
                                                <option value="30"> {trans('random.1month')}</option>
                                                <option value="everyday"> {trans('random.everyDay')}</option>
                                            </select>
                                        </div>
                                    </div>
                                    :
                                    <>
                                    </>
                                }

                                <div className="row" style={{ marginBottom: "10px" }}>
                                    <div className="col">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="status_price_on"
                                                    value="1"
                                                    checked={popup.data && popup.data?.status_price_on}
                                                    onChange={handleCheckboxChange}
                                                    size="small"
                                                />
                                            }
                                            label={trans('random.StatusPrice')}
                                        />
                                        <p style={{ color: "#A3AED0", fontSize: "14px", marginTop: "-5px" }}>
                                            {trans('random.statusPriceDescription')}
                                        </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div
                                        className="col"
                                        style={{
                                            maxWidth: "150px"
                                        }}
                                    >
                                        <input
                                            name='status_price_value'
                                            type="text"
                                            value={popup.data ? popup.data.status_price_value : ''}
                                            className={validations && validations.status_price_value ? 'validate' : ''}
                                            onChange={handleInputChange}
                                            disabled={!(popup.data && popup.data?.status_price_on)}
                                            placeholder={trans('labels.enterAmount')}
                                        />
                                    </div>
                                </div>
                            </>
                        }

                        {popup.tab === 'auto' &&
                            <>
                                <div className='statu-auto-change'>
                                    <div className='about-status'>
                                        <p>
                                            {trans('random.autoStatusChange')}
                                        </p>
                                        <div className='current-status'>
                                            <span
                                                style={{
                                                    backgroundColor: popup.data && popup.data.color ? popup.data.color : '#000',
                                                }}
                                            >
                                            </span>
                                            <b>
                                                {popup.data?.name}
                                            </b>{trans('random.whenCondition')}
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col">
                                            <ul>
                                                {transitions.map((transition, index) => (
                                                    <StorageStatusAutoCondition
                                                        key={transition.id}
                                                        transition={transition}
                                                        index={index}
                                                        updateTransitionField={updateTransitionField}
                                                        removeTransition={removeTransition}
                                                        finalStatuses={finalStatuses}
                                                        initialStatuses={initialStatuses}
                                                        submitAttempted={submitAttempted}
                                                    />
                                                ))}
                                            </ul>
                                            <button type="button" className='button-add button-small' onClick={addTransition}>
                                                {trans('buttons.newAction')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </>
                }

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>

        </div>
    )
}

export default forwardRef(StorageStatus)